export default "__VITE_ASSET__ekuche2L__"